import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';

interface ImageProps {
  className?: string;
  childImageSharp: IGatsbyImageData;
  alt: string;
  onLoadCallback?: () => any;
}

const Image = ({ className, childImageSharp, alt, onLoadCallback }: ImageProps): JSX.Element => {
  return (
    <GatsbyImage
      className={className}
      image={childImageSharp}
      alt={alt}
      onLoad={onLoadCallback ? () => onLoadCallback() : null}
    />
  );
};

export default Image;
